import React from 'react'
import mail from '../../Resources/footer/gmail.png'
import linkedin from '../../Resources/footer/linkedin.png'
import youtube from '../../Resources/footer/youtube.png'
import Typewriter from 'typewriter-effect';
import git from '../../Resources/footer/git.png'

const OpenToWork = () => {
    return (
        <>
            <div className="otw_container" id='otw'>
                <div className="otw_split_left">
                    <h1><Typewriter
                        options={{
                            strings: ['Open to freelance work'],
                            autoStart: true,
                            loop: true,
                            cursor: "...",
                            delay: 80,
                            pauseFor: 5000,
                        }}
                    /></h1>
                    <h2>Reach out to me if you need a project done or a concert</h2>
                </div>
                <div className="otw_split_right">
                    <div className="otw_split_right_contacts">
                        <div className="otw_split_right_contact_info">
                            <h3>Email ·</h3>
                            <p>You can always reach out to me at <a href='mailto:sadhgunaithal@outlook.com' target="_blank" rel="noopener noreferrer">sadhgunaithal@outlook.com</a></p>
                        </div>
                        <div className="otw_split_right_contact_info">
                            <h3>Location ·</h3>
                            <p>I am currently located in the sunny part of Mangalore</p>
                        </div>
                    </div>
                    <div className="otw_imaged_links">
                        <a href='https://github.com/ape-with-helmet' target="_blank" rel="noopener noreferrer"><img src={git} alt='GitHub' /></a>
                        <a href='https://www.linkedin.com/in/sadhguna-aithal/' target="_blank" rel="noopener noreferrer"><img src={linkedin} alt='linkedin'/></a>
                        <a href='https://www.youtube.com/@SadhgunAithal' target="_blank" rel="noopener noreferrer"><img src={youtube} alt='Youtube' /></a>
                        <a href='mailto:sadhgunaithal@outlook.com' target="_blank" rel="noopener noreferrer"><img src={mail} alt='mail'/></a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OpenToWork